export default {
  title: 'Plată',
  description: 'Toate tranzacțiile sunt securizate și criptate',
  show_more_payment_methods: 'Afișează mai multe metode de plată',
  express_checkout_divider: 'sau',
};
